import { ChatModuleType } from '../copied/models/ChatModules';
import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useCategories() {
  const { data: helpCenter } = useFetchHelpCenter();
  const knowledgeBase = helpCenter?.modules?.find(
    (module) =>
      (module.module_type === ChatModuleType.KnowledgeBase || module.module_type === ChatModuleType.TAIlor) &&
      module.document_categories
  );
  const categories = knowledgeBase?.document_categories;
  return categories || [];
}
